import { render } from "./ALBAYADIA(ISIS) Hospital.vue?vue&type=template&id=4dd97ac5&scoped=true"
const script = {}

import "./ALBAYADIA(ISIS) Hospital.vue?vue&type=style&index=0&id=4dd97ac5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4dd97ac5"

export default script